import { useState } from 'react';
import { useApp } from '../../context/AppContext.jsx';

const STRUCT_OPTIONS = [
  { value: '', label: '-- Structure --' },
  { value: 'LILLYBELLE_BURKINA', label: 'Lillybelle Burkina' },
  { value: 'LILLYBELLE', label: 'Lillybelle France' },
  { value: 'LILLYBELLE_H', label: 'Lillybelle Group' },
  { value: 'LILLYBELLE_SENEGAL', label: 'Lillybelle Sénégal' },
  { value: 'LILLYBELLE_TOGO', label: 'Lillybelle Togo' }
];

export function ManageModal() {
  const {
    manageOpen,
    setManageOpen,
    manualCollaborators,
    addManualCollab,
    updateManualCollab,
    deleteManualCollab
  } = useApp();

  const [addName, setAddName] = useState('');
  const [addStruct, setAddStruct] = useState('');

  if (!manageOpen) return null;

  const handleAdd = () => {
    if (!addName.trim() || !addStruct) {
      alert('Veuillez remplir tous les champs');
      return;
    }
    addManualCollab(addName.trim(), addStruct);
    setAddName('');
    setAddStruct('');
  };

  return (
    <div
      id="manageOverlay"
      style={{
        display: 'flex',
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 1000,
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onClick={(e) => e.target.id === 'manageOverlay' && setManageOpen(false)}
    >
      <div
        style={{
          background: '#FFF',
          borderRadius: 14,
          padding: '28px 32px',
          maxWidth: 600,
          width: '92%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
          maxHeight: '85vh',
          display: 'flex',
          flexDirection: 'column'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
          <div style={{ fontSize: 16, fontWeight: 600 }}>Gestion des collaborateurs</div>
          <button type="button" onClick={() => setManageOpen(false)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#6B6860' }}>×</button>
        </div>
        <div style={{ fontSize: 13, color: '#6B6860', marginBottom: 14 }}>
          Collaborateurs mémorisés manuellement. Vous pouvez modifier ou supprimer une assignation.
        </div>
        <div id="manageList" style={{ flex: 1, overflowY: 'auto', border: '1px solid #E2DED6', borderRadius: 8 }}>
          {Object.keys(manualCollaborators).length === 0 ? (
            <div style={{ padding: '30px 20px', textAlign: 'center', color: '#999', fontSize: 13 }}>
              Aucun collaborateur mémorisé manuellement
            </div>
          ) : (
            Object.entries(manualCollaborators).map(([name, struct]) => (
              <div key={name} className="manage-item">
                <div className="manage-item-name">{name}</div>
                <div className="manage-item-struct">
                  <select
                    value={struct}
                    onChange={(e) => updateManualCollab(name, e.target.value)}
                    style={{ padding: '4px 8px', border: '1px solid #E2DED6', borderRadius: 4, fontSize: 12, fontFamily: 'inherit' }}
                  >
                    {STRUCT_OPTIONS.filter((o) => o.value).map((opt) => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
                <button
                  type="button"
                  className="manage-item-delete"
                  onClick={() => deleteManualCollab(name)}
                  style={{ padding: '4px 8px', background: '#FEE2E2', color: '#991B1B', border: 'none', borderRadius: 4, fontSize: 12, cursor: 'pointer' }}
                >
                  Supprimer
                </button>
              </div>
            ))
          )}
        </div>
        <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid #E2DED6' }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: '#6B6860', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            Ajouter manuellement
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              value={addName}
              onChange={(e) => setAddName(e.target.value)}
              placeholder="Nom complet"
              style={{ flex: 1, padding: '7px 10px', border: '1px solid #E2DED6', borderRadius: 7, fontSize: 13, fontFamily: 'inherit' }}
            />
            <select
              value={addStruct}
              onChange={(e) => setAddStruct(e.target.value)}
              style={{ padding: '7px 10px', border: '1px solid #E2DED6', borderRadius: 7, fontSize: 13, fontFamily: 'inherit' }}
            >
              {STRUCT_OPTIONS.map((opt) => (
                <option key={opt.value || 'empty'} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <button type="button" onClick={handleAdd} style={{ padding: '7px 14px', background: '#1A1916', color: '#FFF', border: 'none', borderRadius: 7, fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit' }}>
              Ajouter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


